import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { StorageEngine } from '@ngxs/storage-plugin';

export const STORAGE_APP_ID = new InjectionToken<string>('STORAGE_APP_ID');

@Injectable()
export class HostAwareStorageEngine implements StorageEngine {

	private readonly PREFIXED_KEYS = ['@@STATE'];
	private readonly suffix: string;

	constructor(@Optional() @Inject(STORAGE_APP_ID) appId: string | null) {
		const parts = window.location.hostname.split('.');
		const domain = parts.length > 1 ? parts[parts.length - 2] : parts[0];
		this.suffix = appId ? `${domain}-${appId}` : domain;
	}

	get length(): number {
		return localStorage.length;
	}

	getItem(key: string): any {
		return localStorage.getItem(this.buildKey(key));
	}

	setItem(key: string, val: any): void {
		localStorage.setItem(this.buildKey(key), val);
	}

	removeItem(key: string): void {
		localStorage.removeItem(this.buildKey(key));
	}

	clear(): void {
		localStorage.clear();
	}

	private buildKey(key: string): string {
		return this.PREFIXED_KEYS.includes(key) ? `${key}-${this.suffix}` : key;
	}
}
